import moment from "moment";

export const getCustomPmSessionDateRange = (month, year) => {
  const y = parseInt(year);

  if (y === 2026) {
    if (month === "January") {
      return {
        startDate: moment("2026-01-01").startOf("day"),
        endDate: moment("2026-01-30").endOf("day")
      };
    }
    if (month === "February") {
      return {
        startDate: moment("2026-01-31").startOf("day"),
        endDate: moment("2026-03-01").endOf("day")
      };
    }
    if (month === "March") {
      return {
        startDate: moment("2026-03-02").startOf("day"),
        endDate: moment("2026-03-31").endOf("day")
      };
    }
  }

  // Default: standard month boundaries for all other months/years
  const ref = moment(`${y}-01-01`).month(month);
  return {
    startDate: ref.clone().startOf("month"),
    endDate: ref.clone().endOf("month")
  };
};

/**
 * Calendar month (MM) + year → PM session window as YYYY-MM-DD for API payloads.
 * Uses getCustomPmSessionDateRange (e.g. 2026 Jan–Mar split months).
 */
export const getPmSessionMonthRangeStrings = (year, monthMM) => {
  const y = String(year);
  const m = String(monthMM).padStart(2, "0");
  const monthName = moment(`${y}-${m}-01`).format("MMMM");
  const { startDate, endDate } = getCustomPmSessionDateRange(monthName, y);
  return {
    startDate: startDate.format("YYYY-MM-DD"),
    endDate: endDate.format("YYYY-MM-DD")
  };
};
